import { Turbo } from "@hotwired/turbo-rails"

let pendingResolve = null
let previousFocus = null

function elements() {
  return {
    root: document.getElementById("turbo-confirm-modal"),
    backdrop: document.getElementById("turbo-confirm-backdrop"),
    message: document.getElementById("turbo-confirm-message"),
    confirmBtn: document.getElementById("turbo-confirm-ok"),
    cancelBtn: document.getElementById("turbo-confirm-cancel"),
  }
}

function closeModal(result) {
  const { root } = elements()
  if (!root) return

  root.classList.add("hidden")
  root.classList.remove("flex")
  root.setAttribute("aria-hidden", "true")
  document.body.classList.remove("overflow-hidden")

  const resolve = pendingResolve
  pendingResolve = null
  if (resolve) resolve(result)

  if (previousFocus?.focus) {
    try {
      previousFocus.focus({ preventScroll: true })
    } catch (_) {
      /* ignore */
    }
  }
  previousFocus = null
}

function openModal(text) {
  const { root, message, confirmBtn } = elements()
  if (!root || !message) return false

  message.textContent = text
  previousFocus = document.activeElement
  root.classList.remove("hidden")
  root.classList.add("flex")
  root.setAttribute("aria-hidden", "false")
  document.body.classList.add("overflow-hidden")
  requestAnimationFrame(() => confirmBtn?.focus())
  return true
}

function install() {
  Turbo.config.forms.confirm = (message, _form, _submitter) => {
    return new Promise((resolve) => {
      if (!openModal(message)) {
        resolve(window.confirm(message))
        return
      }
      pendingResolve = resolve
    })
  }

  document.addEventListener("click", (e) => {
    if (!pendingResolve) return

    if (e.target.closest("#turbo-confirm-ok")) {
      closeModal(true)
    } else if (e.target.closest("#turbo-confirm-cancel") || e.target.id === "turbo-confirm-backdrop") {
      closeModal(false)
    }
  })

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || !pendingResolve) return
    e.preventDefault()
    closeModal(false)
  })
}

install()
